import { render } from "./LeaveAssign.vue?vue&type=template&id=23e78cd6"
import script from "./LeaveAssign.vue?vue&type=script&lang=js"
export * from "./LeaveAssign.vue?vue&type=script&lang=js"

import exportComponent from "/app/src/client/.yarn/__virtual__/vue-loader-virtual-e12e5a5897/0/cache/vue-loader-npm-17.0.1-f552b82805-b10a7b05ba.zip/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__